import { IReportValidationErrorParams, IReportValidationErrorResponse } from "../../interfaces/api/skynet/reportValidationError"
import { IValidateDietPlanParams, IValidateDietPlanResponse } from "../../interfaces/api/skynet/validateDietPlan"
import ApiUtils from "../ApiUtils"
import { ISkynetService } from "./ISkynetService"

const SkynetUrls = {
	validateDietPlan: "/dietplan/validation",
	reportError: "/dietplan/report",
}

export default class SkynetServiceApis implements ISkynetService {
	getServiceUrl = (path: string): string => "/skynet" + path

	validateDietPlan = (params: IValidateDietPlanParams): Promise<IValidateDietPlanResponse> => {
		const url = this.getServiceUrl(SkynetUrls.validateDietPlan)
		return ApiUtils.post(url, params)
	}

	reportValidationError = (params: IReportValidationErrorParams): Promise<IReportValidationErrorResponse> => {
		const url = this.getServiceUrl(SkynetUrls.reportError)
		return ApiUtils.post(url, params)
	}
}
